<template>
        <div class="uk-container uk-container-expand">
          <tab-bar></tab-bar>
             <form @submit.prevent="updateDate"> 
               <div class="uk-flex uk-flex-center ">
                 <div class="uk-card uk-card-default my-5 py-4 my-3 px-3 uk-width-1-3">
                     <div class="uk-margin">
                        <label>Choisir date de début</label>
                        <div>
                          <input class="uk-input" type="date" v-model="date.debut">
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label>Choisir date de fin</label>
                         <div>
                          <input class="uk-input" type="date" v-model="date.fin">
                        </div>
                      </div>
                     <button class="uk-button uk-button-primary uk-text-right" >Valider</button>
                  </div>
               </div>
            </form>
        <div class="uk-card uk-card-default  uk-width-1-1@m mt-0 p-2" v-if="show == true">
            <h4 class="uk-text-center">Rapport Provisoire (par tranche journalière)</h4>
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-striped">
                <thead>
                   <tr>
                        <th>N°</th>
                        <th>Nature de colis</th>
                        <th>Nom du client</th>
                        <th>Contact du client</th>
                        <th>Date & Heure : </th>
                        <th>Montant du Colis</th>
                        <th>Frais de livraison</th>
                        <th>Nom du livreur</th>
                    </tr> 
                </thead>
                <tbody>
                    <tr v-for="(colis,item) in colisDuJour" :key="colis.id">
                        <td>{{item+1}}</td>
                        <td>{{colis.nature}}</td>
                        <td>{{colis.client_name}}</td>
                        <td>{{colis.client_phone}}</td>
                        <td>{{colis.created_at}}</td>
                        <td>{{colis.valeur}}</td>
                        <td>{{colis.montant}}</td>
                        <td></td>
                    </tr> 
                </tbody>
            </table>
            </div>
            <div class="uk-flex uk-flex-center">
            <div class="my-3 uk-flex uk-flex-center">
                <p class="my-3 mx-5 uk-text-center">
                  <button class="uk-button uk-button-default uk-button-small">Valeurs de colis</button>
                  <button class="uk-button uk-button-primary uk-button-small" id="btn"><b>{{ valeurs }}</b> F CFA</button>
                </p>
                <p class="my-3 mx-5 uk-text-center">
                  <button class="uk-button uk-button-default uk-button-small">Frais de livraison</button>
                  <button class="uk-button uk-button-primary uk-button-small" id="btn"><b>{{ total }}</b> F CFA</button>
                </p>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import { colors } from "vuetify/lib";
import { db } from "../../main";
export default {
    data() {
    return {
      date:{
        debut:"",
        fin:""
      },
      commande: {
        statut: "",
        livreur_id: "",
      },
      Colis: {},
      ValeurTotal: {},
      Livreur: {},
      colisDuJour: [],
      show: false,
    };
  },

  methods:{
    updateDate(){
      let dbRef = db.ref("Colis Requetes")
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
        this.ValeurTotal = childData
      })
      .catch((error) => {
        console.log(error);
      });
    db.ref("Colis Requetes")
      .orderByChild("created_at")
      .once("value")
      .then((dataSnapshot) => {
        dataSnapshot.forEach((childSnapshot) => {
          this.colisDuJour.push(childSnapshot.val())
        });
          this.show = true;
      });
    }
  },
  computed: {
    total() {
      let total = 0;
      this.colisDuJour.forEach((colis) => {
        total += Number.parseInt(colis.montant);
      });
      return total;
    },
    valeurs(){
      let valeurs = 0;
      this.colisDuJour.forEach((colis) => {
        valeurs += Number.parseInt(colis.valeur)
      });
      return valeurs;
    }
}
}
</script>

<style>
#btn {
  background-color: #34c494;
}

</style>